// src/data/texts.js
export const texts = {
    de: {
        title: "Willkommen zu deiner Tarot-Lesung",
        description: "Ziehe eine Karte und entdecke deine Botschaft!",
        personalReading: "Persönliche Legung buchen",
        donate: "Spenden",
        language: "Sprache wechseln",

        headerHome: "Home",
        headerReading: "Tarot Lesung",
        headerAbout: "Über uns",
        headerContact: "Kontakt"
    },
    en: {
        title: "Welcome to your Tarot Reading",
        description: "Draw a card and discover your message!",
        personalReading: "Book a Personal Reading",
        donate: "Donate",
        language: "Change Language",
        
        headerHome: "Home",
        headerReading: "Tarot Reading",
        headerAbout: "About",
        headerContact: "Contact"
    },
};
